function createKeyedPromiseCache(loader) {
  const requests = new Map()

  return function get(key) {
    if (requests.has(key)) return requests.get(key)

    let loaded
    try {
      loaded = loader(key)
    } catch (error) {
      loaded = Promise.reject(error)
    }
    const request = Promise.resolve(loaded).catch((error) => {
      if (requests.get(key) === request) requests.delete(key)
      throw error
    })
    requests.set(key, request)
    return request
  }
}

function createLatestSiteRequestGuard() {
  let sequence = 0

  return {
    start(siteType) {
      sequence += 1
      return { siteType, sequence }
    },
    isCurrent(request, currentSiteType) {
      return Boolean(request) && request.sequence === sequence && request.siteType === currentSiteType
    }
  }
}

module.exports = {
  createKeyedPromiseCache,
  createLatestSiteRequestGuard
}

